export default __webpack_public_path__ + "static/thirdweb-6e65f3557848418bd7f29587c82d33c3.svg";